export default [
  {
    path: '/access-control',
    name: 'access-control',
    component: () => import('@/views/extensions/acl/AccessControl.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/access-control2',
    name: 'access-control2',
    component: () => import('@/views/extensions/acl/AccessControl2.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
]
